import { Facebook, Instagram, LinkedIn, X } from "@mui/icons-material";
import { CustomInput } from "../../../Common/CustomInputs";
import { Gapper } from "../../../ui/Gapper";
import { SectionHeader, SocialsGrid } from "../practitionerForm.styles";
import { colors } from "../../../../theme/theme";
import * as C from "../practitionerForm.constants";

const SOCIAL_ICONS = { LinkedIn, X, Facebook, Instagram };

const WebsiteAndSocialsSection = ({ submitData, updateField }) => {
  return (
    <Gapper gap={15}>
      <SectionHeader>{C.WEBSITE_SOCIALS_SECTION_TITLE}</SectionHeader>
      <CustomInput
        value={submitData.website}
        setValue={(value) => updateField("website", value)}
        placeholder={C.WEBSITE_SOCIALS_FIELDS[0].placeholder}
        label={C.WEBSITE_SOCIALS_FIELDS[0].label}
        smallBr
        bR="14px"
        width="100%"
        noIcon
        color={colors.primary}
      />
      <SocialsGrid>
        {C.WEBSITE_SOCIALS_FIELDS.slice(1).map((field) => (
          <CustomInput
            key={field.name}
            value={submitData[field.name]}
            setValue={(value) => updateField(field.name, value)}
            placeholder={field.placeholder}
            label={field.label}
            smallBr
            bR="14px"
            width="100%"
            Icon={SOCIAL_ICONS[field.iconKey]}
            iconColor={field.iconColor}
            color={colors.primary}
          />
        ))}
      </SocialsGrid>
    </Gapper>
  );
};

export default WebsiteAndSocialsSection;
